'use client'

import ErrorPageContent from 'src/components/pages/ErrorPageContent'

export default function Error() {
  return <ErrorPageContent type='error' />
}
